// extracted by mini-css-extract-plugin
var _1 = "Notification-modulecheckbox__scT7_";
var _2 = "Notification-moduleclose__KmKPB";
var _3 = "Notification-modulecontent__fNy67";
var _4 = "Notification-modulecreationTime__QFUlu";
var _5 = "Notification-moduleerror__LpEux";
var _6 = "Notification-moduleicon__P1Afg IconNG-moduleiconContainer__SxWZ0";
var _7 = "Notification-moduleinfo__Ppfrv";
var _8 = "Notification-modulelink__B7U_6";
var _9 = "Notification-modulenotification__xsYHD";
var _a = "Notification-modulesuccess__ZB25k";
var _b = "Notification-moduletext__Q4sMn ClampingText-moduleclampingText__ANX4H";
var _c = "Notification-moduletextButton__MhXdl";
var _d = "Notification-moduletitle___JHfB";
var _e = "Notification-modulewarning__zN17S";
export { _1 as "checkbox", _2 as "close", _3 as "content", _4 as "creationTime", _5 as "error", _6 as "icon", _7 as "info", _8 as "link", _9 as "notification", _a as "success", _b as "text", _c as "textButton", _d as "title", _e as "warning" }
